import { type PhysicalAddress } from '@ctct/data-query';
import { getGeolocatedAddressDefaults, LocationUtils } from '@ctct/rise-utils';

const getFormKey = (prefix: string | undefined, key: string) => (prefix ? `${prefix}.${key}` : key);

const resolveStateCode = (state: string | undefined, countryCode: string): string => {
  const raw = (state ?? '').trim();
  if (!raw) return '';

  const pool = countryCode === 'ca' ? LocationUtils.provinces : LocationUtils.states;
  const match = pool.find(
    (entry) =>
      entry.abbreviation.toLowerCase() === raw.toLowerCase()
      || entry.name.toLowerCase() === raw.toLowerCase()
  );
  return match?.abbreviation ?? raw;
};

const getPhysicalAddressDefaults = (address?: Partial<PhysicalAddress> | null): PhysicalAddress => {
  const geolocatedDefaults = getGeolocatedAddressDefaults();
  const countryCode =
    address?.countryCode?.trim().toLowerCase()
    || geolocatedDefaults.countryCode.trim().toLowerCase();
  const shouldUseGeolocatedRegion =
    countryCode === geolocatedDefaults.countryCode.trim().toLowerCase();
  const geolocatedRegion = shouldUseGeolocatedRegion ? geolocatedDefaults.stateCode : '';
  const isStateCodeCountry = countryCode === 'us' || countryCode === 'ca';
  const geolocatedStateCode = isStateCodeCountry ? geolocatedRegion.toUpperCase() : '';

  return {
    addressLine1: address?.addressLine1 ?? '',
    addressLine2: address?.addressLine2 ?? '',
    city: address?.city ?? '',
    countryCode,
    postalCode: address?.postalCode ?? '',
    stateCode: isStateCodeCountry
      ? resolveStateCode(
          address?.stateCode || address?.stateName || geolocatedStateCode,
          countryCode
        ).toUpperCase()
      : (address?.stateCode ?? ''),
    stateName: isStateCodeCountry
      ? (address?.stateName ?? '')
      : (address?.stateName ?? geolocatedRegion),
  };
};

export { getFormKey, getPhysicalAddressDefaults };
